import { useEffect } from 'react'
import { useProfile } from '@/hooks/useProfile'
import useTracking from '@/lib/tracking/useTracking'
import { TRACKER_READY_EVENT } from '@/lib/tracking/Tracker'

export default function useBindLineInfo () {
  const { profile } = useProfile()
  const { tracker } = useTracking()

  useEffect(() => {
    tracker?.set('appVersion', liff.getLineVersion())
    if (profile?.mid) {
      tracker?.set('mid', profile.mid)
      console.log('[Tracker] tracker setup ready')

      window.dispatchEvent(new Event(TRACKER_READY_EVENT))
    }
  }, [profile?.mid])
}
